import { render, staticRenderFns } from "./DeviceAlerts.vue?vue&type=template&id=24fc4b78"
import script from "./DeviceAlerts.vue?vue&type=script&lang=js"
export * from "./DeviceAlerts.vue?vue&type=script&lang=js"
import style0 from "./DeviceAlerts.vue?vue&type=style&index=0&id=24fc4b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports